import { Box, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { Trans } from "react-i18next";
import { getResourcePath } from "web_myplann/Infrastructure/Translations/Resources";
import type { InspirationToneNoteContent } from "web_myplann/Inspiration/Types/InspirationTypes";

export const InspirationToneNote: FC<InspirationToneNoteContent> = ({
	color,
	icon: Icon,
	text,
	values,
}) => {
	const theme = useTheme();
	const tone = theme.palette[color];

	return (
		<Stack
			direction="row"
			alignItems="flex-start"
			gap={theme.spacingTokens.sm}
			bgcolor={tone[50]}
			border={theme.colors.border.solid(tone[100])}
			borderRadius={theme.radii.lg}
			p={theme.spacingTokens.md}
		>
			{Icon && (
				<Box display="inline-flex" flexShrink={0} pt={theme.spacingTokens.xxs}>
					<Icon size={theme.iconSize.xs} color={tone.main} />
				</Box>
			)}
			<Typography variant="hint" color={tone[800]} relaxed>
				<Trans
					i18nKey={getResourcePath(text)}
					values={values}
					components={{
						b: (
							<Typography
								component="span"
								variant="hint"
								color="inherit"
								strong
							/>
						),
					}}
				/>
			</Typography>
		</Stack>
	);
};
